module.exports = __webpack_public_path__ + "static/media/type_woongebouw.90764fd9.jpg";